import { Typography } from "@/components/shared/typography";
import { WorkerProfileCard } from "@/components/shared/worker-profile-card";
import { View, Card, CardContent } from "@/components/ui";
import type { Review } from "@/types/booking";
import { ServiceProfessionalScroll } from "./service-professional-scroll";
export const ServiceProfessional = ({
  reviews,
  cleanerInfo,
}: {
  cleanerInfo: { name: string; star: string; avatar: string };
  reviews: Review[];
}) => {
  return (
    <Card className="shadow-slate-200" border="none" shadow="lg">
      <CardContent className="p-0">
        <View className="flex flex-col gap-3 pb-4 pt-4 md:pb-4">
          <Typography
            variant="label-md"
            color="brand-primary"
            className="w-full px-4 md:justify-start"
            align="center"
          >
            Service Professional
          </Typography>
          <View className="flex flex-col gap-4">
            <WorkerProfileCard {...cleanerInfo} key="workerProfile" />
            <ServiceProfessionalScroll reviews={reviews} />
          </View>
        </View>
      </CardContent>
    </Card>
  );
};
